module.exports = __webpack_public_path__ + "img/in_banner1.52a84ac5.png";